import type AlertRecord from 'webapp/models/alert-setting';
import type BlockRecord from 'webapp/models/block';
import type BlockPreviewRecord from 'webapp/models/block-preview';
import type BoardRecord from 'webapp/models/board';
import type BoardLoopRecord from 'webapp/models/board-loop';
import type BoardPreviewRecord from 'webapp/models/board-preview';
import type BoardShareRecord from 'webapp/models/board-share';
import type ClientMetricRecord from 'webapp/models/client-metric';
import type CustomQueryRecord from 'webapp/models/custom-query';
import type DataSelectRecord from 'webapp/models/data-select';
import type ForecastRecord from 'webapp/models/forecast';
import type GoalRecord from 'webapp/models/goal';
import type GroupRecord from 'webapp/models/group';
import type HorizonMetricRecord from 'webapp/models/horizon-metric';
import type MetricRecord from 'webapp/models/metric';
import type MetricAnomalyRecord from 'webapp/models/metric-anomaly';
import type ReminderRecord from 'webapp/models/reminder';
import type ReportRecord from 'webapp/models/report';
import type ReportDeliveryRecord from 'webapp/models/report-delivery';
import type ReportScheduleRecord from 'webapp/models/report-schedule';
import type ReportScheduleSettingRecord from 'webapp/models/report-schedule-setting';
import type ReportSlideRecord from 'webapp/models/report-slide';
import type ReportSlideFragmentRecord from 'webapp/models/report-slide-fragment';
import type SampleRecord from 'webapp/models/sample';
import type ScorecardRecord from 'webapp/models/scorecard';
import type ScriptRecord from 'webapp/models/script';
import type SourceRecord from 'webapp/models/source';
import type SpaceRecord from 'webapp/models/space';
import type TagRecord from 'webapp/models/tag';
import type TemplateRecord from 'webapp/models/template';
import type UserRecord from 'webapp/models/user';

type CustomMetricRecord = CustomQueryRecord | ScriptRecord;

export {
	type AlertRecord,
	type BlockPreviewRecord,
	type BlockRecord,
	type BoardLoopRecord,
	type BoardPreviewRecord,
	type BoardRecord,
	type BoardShareRecord,
	type ClientMetricRecord,
	type CustomMetricRecord,
	type CustomQueryRecord,
	type DataSelectRecord,
	type ForecastRecord,
	type GoalRecord,
	type GroupRecord,
	type HorizonMetricRecord,
	type MetricRecord,
	type MetricAnomalyRecord,
	type ReminderRecord,
	type ReportDeliveryRecord,
	type ReportRecord,
	type ReportScheduleRecord,
	type ReportScheduleSettingRecord,
	type ReportSlideFragmentRecord,
	type ReportSlideRecord,
	type SampleRecord,
	type ScorecardRecord,
	type ScriptRecord,
	type SourceRecord,
	type SpaceRecord,
	type TagRecord,
	type TemplateRecord,
	type UserRecord,
};
